import { Box, Table, Tbody, Th, Thead, Tr } from "@chakra-ui/react";
import React from "react";

type Props = {
  children: React.ReactNode;
  columns: React.ReactNode[];
};

export default function EntityProfileTable(props: Props) {
  return (
    <Box overflowX="auto">
      <Table size="sm" variant="simple">
        <Thead>
          <Tr>
            {props.columns.map((column, index) => (
              <Th key={index}>{column}</Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>{props.children}</Tbody>
      </Table>
    </Box>
  );
}
